<template>
  <label class="filters-value-row">
    <input
      v-model="selectedFilters[screenType.type]"
      :value="attribute.id"
      type="checkbox"
      hidden
    >
    <span :class="{checked}">{{ attribute.name }}</span>
    <UIIcon
      v-if="checked"
      name="check"
    />
  </label>
</template>

<script lang="ts" setup>
import { useFilters, useFiltersByAttributes } from '~/services/catalogFilter/useCatalogFilters';
import {
  useStateAttributes,
  useStateAvailableFilters,
  useStateSelectedFilters,
} from '~/services/catalogFilter/useAvailableFilters';
import { TCheckboxQueryParamName } from '~/types/filters';
import UIIcon from '~/components/ui/UIIcon.vue';
import { AttributeDTO } from '~/restAPI/data-contracts';

const props = defineProps<{
  screenType: { type: TCheckboxQueryParamName, id: TCheckboxQueryParamName | number } | undefined
  attribute: AttributeDTO
  checked: boolean
}>();

const filters = useFilters();
const attributes = useStateAttributes();
const filtersByAttributes = useFiltersByAttributes();
const availableFilters = useStateAvailableFilters();
const selectedFilters = useStateSelectedFilters();
</script>

<style scoped lang="scss">
.filters-value-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 30px 12px 0;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;

  span.checked {
    font-weight: 700;
  }
}
</style>
